import React from 'react';

import AdminLayout from '../../components/AdminLayout';
import Notifications from './Notifications';

const NotificationsPage = () => {
    return (
        <AdminLayout>
            <Notifications />
        </AdminLayout>
    );
};

export default NotificationsPage;
